import React from "react";
import PropTypes from "prop-types";
import {withStyles} from "@material-ui/core/styles";

import RiddleCircleTile from "./riddle-circle-tile";
import {getTranslation} from "../../helpers/get-translation";

const styles = theme => ({
	root: {
		// display: 'flex',
		backgroundImage: `url("${getTranslation("image_solved_riddle_background")}")`,
		backgroundSize: 'contain',
		bottom: 0,
		width: '100%',
		height: '150px',
		position: "relative",
		flex: 1,
		"-webkit-box-shadow": "0px -6px 4px -1px rgba(0,0,0,0.2),0px 4px 5px 0px rgba(0,0,0,0.14),0px 1px 10px 0px rgba(0,0,0,0.12)",
		"box-shadow": "0px -6px 4px -1px rgba(0,0,0,0.2),0px 4px 5px 0px rgba(0,0,0,0.14),0px 1px 10px 0px rgba(0,0,0,0.12)",

	},
	text: {
		width: '100%',
		color: 'white',
		textAlign: 'center',
		fontSize: '42px',
		paddingTop: '25px',
		"& div:first-child": {
			marginBottom: '8px'
		},
		"& div:nth-child(2)": {
			fontSize: '25px'
		}
	},
	points:{
		height: "40px",
		marginBottom: "13px"
	},
	"@media (max-width: 600px)":{
		root:{
			minHeight: '130px',
		},
		text: {
			paddingTop: '10px',
		},
		points: {
			marginBottom: "0px"
		}
	},
	"@media (max-height: 500px)":{
		root:{
			minHeight: '135px',
		},
	}
});
// setActiveRiddle(logo, index);



function GuessedRiddleNavigation(props) {
	const { classes,
		successText,
		points,
		previousRiddle,
		nextRiddle,
		navigationClick,
		isLoading } = props;

	return (
		<div className={classes.root}>
			<RiddleCircleTile riddle={previousRiddle} navigationClick={navigationClick} isLoading={isLoading} direction='prev'/>
			<div className={classes.text}>
				<div>{getTranslation(successText)}</div>
				<div className={classes.points}>
				{points > 0 && <img src={getTranslation("image_logo_starts_prefix") + points + ".png"}/>}
				</div>
			</div>
			<RiddleCircleTile riddle={nextRiddle} navigationClick={navigationClick} isLoading={isLoading} direction='next'/>
		</div>
	);
}

GuessedRiddleNavigation.propTypes = {
	isLoading: PropTypes.bool.isRequired,

	successText: PropTypes.string.isRequired,

	classes: PropTypes.shape({
		root: PropTypes.string.isRequired,
	}).isRequired,

	currentRiddleRange: PropTypes.string.isRequired,
	gameType: PropTypes.string.isRequired,

	userRiddles: PropTypes.object.isRequired,
	previousRiddle: PropTypes.object,
	nextRiddle: PropTypes.object,

	navigationClick: PropTypes.func.isRequired,
};

export default withStyles(styles)(GuessedRiddleNavigation);

